<app-top-navigation [openLoginWindow]="isLoginOpen"></app-top-navigation>
<div class="accountContainer">
	<div class="row">
		<div class="col-md-4" *ngIf="userObservable | async as user">
			<div class="image-container">
				<img *ngIf="user.image && user.image.length <=3" src="assets/images/remotes/no-image-user.jpg" />
				<img *ngIf="user.image && user.image.length >3" [src]="user.image" />
			</div>
			<div class="user-info">
				{{user.name.toLowerCase()}} {{user.lastName.toLowerCase()}}
			</div>
			<ul class="selections">
				<li [class.active]="navigationStep === 1" (click)="changeView(1)">
					<span><fa-icon [icon]="['fas','user']"></fa-icon></span>
					Basic Information
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li [class.active]="navigationStep === 2" (click)="changeView(2)">
					<span><fa-icon [icon]="['fas','truck-moving']"></fa-icon></span>
					Billing Information
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li [class.active]="navigationStep === 3" (click)="changeView(3)">
					<span><fa-icon [icon]="['fas','lock']"></fa-icon></span>
					Change Password
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li [class.active]="navigationStep === 4" (click)="changeView(4)">
					<span><fa-icon [icon]="['fas','shopping-cart']"></fa-icon></span>
					Revenue Analysis
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li [class.active]="navigationStep === 4" (click)="changeView(4)">
					<span><fa-icon [icon]="['fas','list']"></fa-icon></span>
					Future Meetings
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li>
					<span><fa-icon [icon]="['fas','edit']"></fa-icon></span>
					Manage cultural routes
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li>
					<span><fa-icon [icon]="['fas','calendar-alt']"></fa-icon></span>
					Route Availability
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li [class.active]="navigationStep === 5" class="text-danger" (click)="changeView(5)">
					<span><fa-icon [icon]="['fas','directions']"></fa-icon></span>
					Virtual Tour Preparation
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
				<li [class.active]="navigationStep === 6" (click)="changeView(6)">
					<span><fa-icon [icon]="['fas','trash']"></fa-icon></span>
					Delete Account
					<fa-icon [icon]="['fas','chevron-right']"></fa-icon>
				</li>
			</ul>
		</div>
		<div class="col-md-8">
			<div class="text-center" style="height: 100%; position: absolute; width: 100%;z-index: 100; background: rgba(255,255,255,0.6)"
				 *ngIf="flowLoading">
				<div class="loader-block" style="margin-top: 25%">
					<svg id="loader2" viewBox="0 0 100 100">
						<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
					</svg>
				</div>
				<div>LOADING....</div>
			</div>
			<h1 style="margin-bottom: 30px">Account</h1>
			<ng-container *ngIf="navigationStep === 1">
				<form [formGroup]="basicInfoForm">
					<app-user-basic-info [columns]="1" formControlName="basicInfo"></app-user-basic-info>
				</form>
				<button class="next-button btn btn-primary" style="margin-top: 30px" (click)="saveInfo(basicInfoForm)"> Update Information
				</button>
			</ng-container>
			<ng-container *ngIf="navigationStep === 2">
				<form [formGroup]="billingInfoForm">
					<app-user-billing-info [columns]="1" formControlName="billingInfo"></app-user-billing-info>
				</form>
				<button class="next-button btn btn-primary" style="margin-top: 30px" (click)="saveInfo(billingInfoForm)"> Update Billing
				</button>
			</ng-container>
			<ng-container *ngIf="navigationStep === 3">
				<form [formGroup]="userPasswordForm">
					<app-user-password [columns]="1" formControlName="userPassword"></app-user-password>
				</form>
				<button class="next-button btn btn-primary" style="margin-top: 30px" (click)="savePassword()"> Change Password
				</button>
			</ng-container>
			<ng-container *ngIf="navigationStep === 4">
				<table *ngIf="orders$ | async as orders else loader" class="minimalistBlack">
					<thead>
						<tr>
							<th>Archaeological Site</th>
							<th>Price</th>
							<th>Date Start</th>
							<th>Date End</th>
							<th>Invoice</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let order of orders">
							<td *ngIf="getSiteName(order.siteIds) | async as siteName else siteLoading">
								{{siteName}}
							</td>
							<td>{{order.price}} &euro;</td>
							<td>{{order.subscriptionDay | date}}</td>
							<td>{{order.subscriptionEnd | date}}</td>
							<td>Processing...</td>
						</tr>
					</tbody>
				</table>
				<ng-template #loader>
					<div class="step text-center" style="margin-top: 100px">
						<div class="loader-block">
							<svg id="loader2" viewBox="0 0 100 100">
								<circle id="circle-loader2" cx="50" cy="50" r="45"></circle>
							</svg>
						</div>
						<div>LOADING....</div>
					</div>
				</ng-template>
			</ng-container>
			<ng-template #siteLoading>
				Loading..
			</ng-template>
			<ng-container *ngIf="navigationStep === 5">
				<div style="text-align: center;padding: 25vh 0;">
					<h6 style="margin-top: 5vh">Navigation</h6>
					<p>
						By clicking the button you will be redirected to a demo of the <b>Guided Tour Engine</b>
					</p>
					<button class="btn btn-primary" (click)="goToMeeting()">Show the demo</button>
				</div>
			</ng-container>
			<ng-container *ngIf="navigationStep === 6">
				<h6 style="margin-top: 5vh">Permanent deletion</h6>
				<p>This action will permanently delete your account and you will lose all your purchased items. Are you sure you want to delete
				   your account?</p>
				<button (click)="deleteAccount()" class="text-danger">Yes delete it</button>
				<p style="margin-top:5vh;font-size: 0.8rem">
					<em>* Some of your data will be kept for statistical reasons for a short period of time and will not be used for marketing or
						sales purposes.</em>
				</p>
			</ng-container>
		</div>
	</div>
</div>